// import classes from './Header.module.css'
import Box  from '@mui/material/Box'
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Badge from '@mui/material/Badge';
import dynamic from 'next/dynamic';
import { useSelector } from 'react-redux';
import useDialog from '@components/_hooks/useDialog';

const HeaderLoginText = dynamic(() => import("./HeaderLoginText"), {
    ssr: true,
});
const SideBarModalRight = dynamic(() => import("@components/Components/Modals/SideBar/SideBarModal"), {
    ssr: false,
});

const Cart = dynamic(() => import("@components/Components/Nav/Cart"), {
  ssr: false,
});
const StyledBox = dynamic(() => import("@components/Custom/Box/StyledBox"));

const StyledBadge = styled(Badge)(({ theme }) => ({
    // '& .MuiBadge-badge': {
    //   backgroundColor:'#fff',
    //   fontWeight:'800',
    //   color:'var(--color-primary)'
    // },
  
    '& .MuiBadge-badge': {
      // border: `0px solid ${theme.palette.background.paper}`,
      // padding:0,
      // width:15,
      // height:15,
      // borderRadius: '100%',
      fontSize:12,
      backgroundColor:'var(--color-secondary)',
      padding: 0,
      // display: 'block',
      [theme.breakpoints.up('lg')]: {
          top: '15%'
        },
      [theme.breakpoints.down('lg')]: {
          top: 0
      },
    },
  }));
const HeaderTools = () => {
    const cart = useSelector(state => state.cartManagementReducer.cart);
    const global_settings = useSelector(state => state.globalReducer.global_settings);
    const template_settings = useSelector(state => state.globalReducer.template_settings);
    const {dialog, handleDialog} = useDialog();   

    return (
        <>
        <Box className='mr-2 mt-2 d-flex justify-end pb-0' sx={{ minHeight: 50, alignItems: 'end'}}>
            { (global_settings.portal_status && global_settings.portal_status == 'enabled') || (template_settings.portal_status && template_settings.portal_status == 'enabled') && (
              <HeaderLoginText />
            )}
            <StyledBox sx={{marginTop:0.9}}>
            <Button className='basket-button pl-2 pr-3 pt-2 pb-2 text-vertical' variant='contained' onClick={() => handleDialog('right')}>
                <StyledBadge>
                  <Badge 
                    badgeContent={cart?.counter || 0}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                  >
                    <ShoppingCartIcon sx={{color:'#fff', marginLeft:1, fontSize:22}} className={`${ cart?.counter > 0 && 'mr-1'}`}/>
                  </Badge>
                  <Typography fontSize={14} className= {`${ cart?.counter > 0 ? 'ml-2' : 'ml-1'}`}>Cart</Typography> 
                </StyledBadge>
            </Button>
            </StyledBox>
        </Box>
         <Box>
         {dialog['right'].open && <SideBarModalRight anchor={'right'} title={'Cart'} children={<Cart handleDialog={() => handleDialog('right')}/>} handleDialog={() => handleDialog('right')} open={dialog['right'].open}/>}
     </Box>
        </>
    )
}

export default HeaderTools